import { success, error, info, warning, promise } from "@/utils/toast";
import SimplePage from "@/components/structure/SimplePage";

// Demo functions to show toast functionality
const showSuccessToast = () => {
  success("Operation completed successfully!");
};

const showErrorToast = () => {
  error("Something went wrong!");
};

const showInfoToast = () => {
  info("Here's some useful information.");
};

const showWarningToast = () => {
  warning("Please be careful with this action.");
};

const showPromiseToast = () => {
  const mockPromise = new Promise((resolve, reject) => {
    setTimeout(() => {
      Math.random() > 0.5 ? resolve("Success!") : reject("Failed!");
    }, 2000);
  });

  promise(mockPromise, {
    pending: "Processing your request...",
    success: "Request completed successfully!",
    error: "Request failed. Please try again.",
  });
};

export default function ToastDemo() {
  return (
    <SimplePage title="Toast Notifications Demo">
      <div className="p-6 bg-gray-100 rounded-lg">
        <p className="text-gray-600 mb-4">
          Click the buttons below to see different types of toast notifications:
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          <button
            onClick={showSuccessToast}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
          >
            Success Toast
          </button>

          <button
            onClick={showErrorToast}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
          >
            Error Toast
          </button>

          <button
            onClick={showInfoToast}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Info Toast
          </button>

          <button
            onClick={showWarningToast}
            className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 transition-colors"
          >
            Warning Toast
          </button>

          <button
            onClick={showPromiseToast}
            className="px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600 transition-colors col-span-2"
          >
            Promise Toast (Random Result)
          </button>
        </div>
      </div>
    </SimplePage>
  );
}
